<template>
  <div class="card">
    <div class="card-header">
      <h6 class="card-title mb-0 float-start" style="padding-left: 25px">
        {{ title }}
      </h6>
      <button v-if="!isDetail" class="btn btn-default btn-sm float-end" type="button" @click="resetForm">
        <i class="link-icon" data-feather="repeat"></i>
        {{ $t("resetFormTxt") }}
      </button>
    </div>
    <div class="card-body">
      <div v-if="loading" class="d-flex align-items-center mb-3">
        <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
        <strong>{{ $t("loadingTxt") }}...</strong>
      </div>

      <form class="forms-sample" @submit.prevent="submitForm" ref="formElement">
        <div class="row mb-3">
          <div class="col-lg-2">
            <label class="col-form-label" style="padding-left: 25px">Customer Code</label>
          </div>
          <div class="col-lg-4">
            <multiselect v-model="company" :options="fetchCompany" placeholder="Please Select" :disabled="isDetail"
              @search-change="asyncSearchCompany" @select="onSelectCompany" track-by="code" label="code">
              <span slot="noResult">-</span>
            </multiselect>

            <!-- <v-select
              v-model="company"
              :options="fetchCompany"
              label="code"
              return-object
              :disabled="isDetail"
              @input="onSelectCompany"
              @search="asyncSearchCompany"
            ></v-select> -->
            <div v-if="errors.customer_code" class="alert alert-primary mt-2" role="alert">
              {{ errors.customer_code[0] }}
            </div>
          </div>
          <div class="col-lg-6">
            <input v-model="localForm.customer_name" type="text" class="form-control" readonly />
            <div v-if="errors.customer_name" class="alert alert-primary mt-2" role="alert">
              {{ errors.customer_name[0] }}
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-lg-2">
            <label class="col-form-label" style="padding-left: 25px">Pick Location</label>
          </div>
          <div class="col-lg-4">
            <multiselect v-model="pickLocation" :options="fetchPickLocation" :custom-label="locationLabel"
              placeholder="Please Select" :disabled="isDetail" @select="onSelectPickLocation">
              <span slot="noResult">-</span>
            </multiselect>
            <div v-if="errors.pick_location_id" class="alert alert-primary mt-2" role="alert">
              {{ errors.pick_location_id[0] }}
            </div>
          </div>
          <div class="col-lg-3">
            <!-- <v-select :options="pickCityOptions" v-model="localForm.pick_city" label="city" :reduce="item => item.city"
              placeholder="Please Select" :disabled="isDetail" @input="onSelectPickCity"></v-select> -->
            <multiselect v-model="pickCity" :options="pickCityOptions" label="city" track-by="city"
              placeholder="Please Select" :disabled="isDetail" @input="onSelectPickCity">
              <span slot="noResult">-</span>
            </multiselect>

            <div v-if="errors.pick_city" class="alert alert-primary mt-2" role="alert">
              {{ errors.pick_city[0] }}
            </div>
          </div>
          <div class="col-lg-3">
            <!-- <v-select :options="pickProvinceOptions" v-model="localForm.pick_province" label="name"
              :reduce="item => item.name" placeholder="Please Select" :disabled="isDetail"
              @input="onSelectPickProvince"></v-select> -->

            <multiselect v-model="pickProvince" :options="pickProvinceOptions" label="name" track-by="name"
              placeholder="Please Select" :disabled="isDetail" @input="onSelectPickProvince">
              <span slot="noResult">-</span>
            </multiselect>

            <div v-if="errors.pick_province" class="alert alert-primary mt-2" role="alert">
              {{ errors.pick_province[0] }}
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-lg-2">
            <label class="col-form-label" style="padding-left: 25px">Drop Location</label>
          </div>
          <div class="col-lg-4">
            <multiselect v-model="dropLocation" :options="fetchDropLocation" :custom-label="locationLabel"
              placeholder="Please Select" :disabled="isDetail" @select="onSelectDropLocation">
              <span slot="noResult">-</span>
            </multiselect>

            <div v-if="errors.drop_location_id" class="alert alert-primary mt-2" role="alert">
              {{ errors.drop_location_id[0] }}
            </div>
          </div>
          <div class="col-lg-3">
            <multiselect v-model="dropCity" :options="dropCityOptions" label="city" track-by="city"
              placeholder="Please Select" :disabled="isDetail" @input="onSelectDropCity">
              <span slot="noResult">-</span>
            </multiselect>
            <!-- <v-select :options="dropCityOptions" v-model="localForm.drop_city" label="city" :reduce="item => item.city"
              placeholder="Please Select" :disabled="isDetail" @input="onSelectDropCity"></v-select> -->
            <div v-if="errors.drop_city" class="alert alert-primary mt-2" role="alert">
              {{ errors.drop_city[0] }}
            </div>
          </div>
          <div class="col-lg-3">
            <!-- <v-select :options="dropProvinceOptions" v-model="localForm.drop_province" label="name"
              :reduce="item => item.name" placeholder="Please Select" :disabled="isDetail"
              @input="onSelectDropProvince"></v-select> -->

            <multiselect v-model="dropProvince" :options="dropProvinceOptions" label="name" track-by="name"
              placeholder="Please Select" :disabled="isDetail" @input="onSelectDropProvince">
              <span slot="noResult">-</span>
            </multiselect>

            <div v-if="errors.drop_province" class="alert alert-primary mt-2" role="alert">
              {{ errors.drop_province[0] }}
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-lg-2">
            <label class="col-form-label" style="padding-left: 25px">Truck Type</label>
          </div>
          <div class="col-lg-4">
            <multiselect v-model="truckType" :options="fetchTruckType" track-by="type_truck" label="type_truck"
              placeholder="Please Select" :disabled="isDetail">
              <span slot="noResult">-</span>
            </multiselect>
            <div v-if="errors.truck_type" class="alert alert-primary mt-2" role="alert">
              {{ errors.truck_type[0] }}
            </div>
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">Carrier</label>
          </div>
          <div class="col-lg-4">
            <multiselect v-model="carrier" :options="fetchCarrier" :custom-label="carrierLabel"
              placeholder="Please Select Carrier" :disabled="isDetail" @search-change="asyncCarrier">
              <span slot="noResult">-</span>
            </multiselect>
            <div v-if="errors.carrier" class="alert alert-primary mt-2" role="alert">
              {{ errors.carrier[0] }}
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <!-- <div class="col-lg-2">
            <label class="col-form-label" style="padding-left: 25px">Billable Tariff</label>
          </div>
          <div class="col-lg-4">
            <input v-model="localForm.billable_tariff" type="text" class="form-control" :readonly="isDetail" />
            <div v-if="errors.billable_tariff" class="alert alert-primary mt-2" role="alert">
              {{ errors.billable_tariff[0] }}
            </div>
          </div> -->
          <div class="col-lg-2">
            <label class="col-form-label">Charge Code</label>
          </div>
          <div class="col-lg-4">

            <multiselect v-model="chargeCode" :options="fetchChargeCode" label="label" track-by="value"
              placeholder="Please Select" :disabled="isDetail">
              <span slot="noResult">-</span>
            </multiselect>

            <!-- <v-select :options="fetchChargeCode" :disabled="isDetail" v-model="localForm.charge_code" label="label"
              :reduce="item => item.value" /> -->

            <div v-if="errors.charge_code" class="alert alert-primary mt-2" role="alert">
              {{ errors.charge_code[0] }}
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-lg-2">
            <label class="col-form-label" style="padding-left: 25px">Min Value</label>
          </div>
          <div class="col-lg-4">
            <input v-model.number="localForm.min_value" type="number" min="0" class="form-control"
              :readonly="isDetail" />
            <div v-if="errors.min_value" class="alert alert-primary mt-2" role="alert">
              {{ errors.min_value[0] }}
            </div>
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">Max Value</label>
          </div>
          <div class="col-lg-4">
            <input v-model.number="localForm.max_value" type="number" min="0" class="form-control"
              :readonly="isDetail" />
            <div v-if="errors.max_value" class="alert alert-primary mt-2" role="alert">
              {{ errors.max_value[0] }}
            </div>
          </div>
        </div>

        <!-- <div class="row mb-3">
          <div class="col-lg-2">
            <label class="col-form-label" style="padding-left: 25px">Min Percent</label>
          </div>
          <div class="col-lg-4">
            <input v-model.number="localForm.min_percent" type="number" min="0" max="100" class="form-control"
              :readonly="isDetail" />
            <div v-if="errors.min_percent" class="alert alert-primary mt-2" role="alert">
              {{ errors.min_percent[0] }}
            </div>
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">Max Percent</label>
          </div>
          <div class="col-lg-4">
            <input v-model.number="localForm.max_percent" type="number" min="0" max="100" class="form-control"
              :readonly="isDetail" />
            <div v-if="errors.max_percent" class="alert alert-primary mt-2" role="alert">
              {{ errors.max_percent[0] }}
            </div>
          </div>
        </div> -->

        <div v-if="isDetail && localForm.created_at" class="row mb-3">
          <div class="col-lg-3">
            <label class="tx-11 fw-bolder mb-0">Created By</label>
            <p class="text-muted">{{ localForm.create_by }}</p>
          </div>
          <div class="col-lg-3">
            <label class="tx-11 fw-bolder mb-0">Created At</label>
            <p class="text-muted">{{ localForm.created_at }}</p>
          </div>
          <div class="col-lg-3">
            <label class="tx-11 fw-bolder mb-0">Updated By</label>
            <p class="text-muted">{{ localForm.update_by }}</p>
          </div>
          <div class="col-lg-3">
            <label class="tx-11 fw-bolder mb-0">Updated At</label>
            <p class="text-muted">{{ localForm.updated_at }}</p>
          </div>
        </div>

        <div class="card-footer px-0 pb-0">
          <button class="btn btn-warning text-black fw-bolder btn-icon-text" type="button" @click="$emit('cancel')">
            <i class="link-icon" data-feather="arrow-left"></i>
            {{ isDetail ? $t("backMess") : "Cancel" }}
          </button>
          <button v-if="!isDetail" class="btn btn-success text-white fw-bolder btn-icon-text float-end" type="submit"
            :disabled="loading">
            <i class="link-icon" data-feather="save"></i>
            {{ submitLabel }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import multiselect from "vue-multiselect";

function buildEmptyForm() {
  return {
    transport_order_margin_estimasi_id: null,
    customer_id: null,
    customer_code: "",
    customer_name: "",
    pick_location_id: null,
    pick_location: "",
    pick_city: "",
    pick_province: "",
    drop_location_id: null,
    drop_location: "",
    drop_city: "",
    drop_province: "",
    truck_type: "",
    carrier: "",
    billable_tariff: "",
    charge_code: "",
    min_value: "",
    max_value: "",
    min_percent: "",
    max_percent: "",
    create_by: "",
    created_at: "",
    update_by: "",
    updated_at: "",
  };
}

export default {
  name: "MarginEstimasiForm",
  components: {
    multiselect,
  },
  props: {
    title: {
      type: String,
      default: "Master Margin Estimasi",
    },
    submitLabel: {
      type: String,
      default: "Submit",
    },
    value: {
      type: Object,
      default() {
        return buildEmptyForm();
      },
    },
    mode: {
      type: String,
      default: "add",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      localForm: buildEmptyForm(),
      company: null,
      truckType: null,
      carrier: null,
      chargeCode: null,
      pickLocation: null,
      dropLocation: null,
      pickCity: null,
      pickProvince: null,
      dropCity: null,
      dropProvince: null,
      fetchCompany: [],
      fetchTruckType: [],
      fetchCarrier: [],
      fetchChargeCode: [],
      fetchPickLocation: [],
      fetchDropLocation: [],
    };
  },
  computed: {
    isDetail() {
      return this.mode === "detail";
    },
    pickCityOptions() {
      return this.buildCityOptions(
        this.fetchPickLocation,
        this.localForm.pick_city,
        this.localForm.pick_province
      );
    },
    pickProvinceOptions() {
      return this.buildProvinceOptions(this.fetchPickLocation, this.localForm.pick_province);
    },
    dropCityOptions() {
      return this.buildCityOptions(
        this.fetchDropLocation,
        this.localForm.drop_city,
        this.localForm.drop_province
      );
    },
    dropProvinceOptions() {
      return this.buildProvinceOptions(this.fetchDropLocation, this.localForm.drop_province);
    },
  },
  watch: {
    chargeCode(val) {
      this.localForm.charge_code = val?.value || "";
    },
    value: {
      handler(newValue) {
        this.localForm = {
          ...buildEmptyForm(),
          ...newValue,
        };
        this.syncSelections();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.loadCompany();
    this.loadTruckType();
    this.loadCarrier();
    this.loadChargeCode();
  },
  methods: {
    locationLabel(item) {
      if (!item) {
        return "";
      }
      return item.int_code ? item.name + " - " + item.int_code : item.name;
    },

    carrierLabel(item) {
      if (!item) {
        return "";
      }
      return item.carrier_name || item.carrier || "";
    },

    buildCityOptions(locations, currentCity = "", currentProvince = "") {
      const cityMap = new Map();

      (locations || []).forEach((item) => {
        if (!item?.city) {
          return;
        }

        if (!cityMap.has(item.city)) {
          cityMap.set(item.city, {
            city: item.city,
            province: item.province || "",
          });
        }
      });

      if (currentCity && !cityMap.has(currentCity)) {
        cityMap.set(currentCity, {
          city: currentCity,
          province: currentProvince || "",
        });
      }

      return Array.from(cityMap.values()).sort((left, right) =>
        left.city.localeCompare(right.city)
      );
    },

    buildProvinceOptions(locations, currentProvince = "") {
      const provinceMap = new Map();

      (locations || []).forEach((item) => {
        if (!item?.province) {
          return;
        }

        if (!provinceMap.has(item.province)) {
          provinceMap.set(item.province, {
            name: item.province,
          });
        }
      });

      if (currentProvince && !provinceMap.has(currentProvince)) {
        provinceMap.set(currentProvince, {
          name: currentProvince,
        });
      }

      return Array.from(provinceMap.values()).sort((left, right) =>
        left.name.localeCompare(right.name)
      );
    },

    syncSelections() {
      this.company = this.localForm.customer_code
        ? {
          company_id: this.localForm.customer_id,
          code: this.localForm.customer_code,
          name: this.localForm.customer_name,
        }
        : null;

      this.truckType = this.localForm.type_truck
        ? {
          type_truck: this.localForm.type_truck,
        }
        : null;

      this.carrier = this.localForm.carrier
        ? {
          carrier_name: this.localForm.carrier,
        }
        : null;

      this.chargeCode = this.localForm.charge_code
        ? {
          value: this.localForm.charge_code,
          label: this.localForm.charge_code,
        }
        : null;

      this.pickLocation = this.localForm.pick_location
        ? {
          location_id: this.localForm.pick_location_id,
          name: this.localForm.pick_location,
          city: this.localForm.pick_city,
          province: this.localForm.pick_province,
        }
        : null;

      this.dropLocation = this.localForm.drop_location
        ? {
          location_id: this.localForm.drop_location_id,
          name: this.localForm.drop_location,
          city: this.localForm.drop_city,
          province: this.localForm.drop_province,
        }
        : null;

      this.syncAreaSelections("pick");
      this.syncAreaSelections("drop");

      if (this.localForm.customer_id) {
        this.loadLocations(this.localForm.customer_id);
      }
    },

    loadCompany() {
      const baseURI = this.$settings.endPoint + "company/select";
      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = (response.data?.datas?.data || [])
          .filter((item) => item.code !== "ALL")
          .map((item) => ({
            company_id: item.company_id,
            code: item.code,
            name: item.name,
          }));
      });
    },

    asyncSearchCompany(ev) {
      const baseURI = this.$settings.endPoint + "company/select?code=" + (ev || "");
      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = (response.data?.datas?.data || [])
          .filter((item) => item.code !== "ALL")
          .map((item) => ({
            company_id: item.company_id,
            code: item.code,
            name: item.name,
          }));
      });
    },

    onSelectCompany(ev) {
      this.localForm.customer_id = ev?.company_id || null;
      this.localForm.customer_code = ev?.code || "";
      this.localForm.customer_name = ev?.name || "";
      this.pickLocation = null;
      this.dropLocation = null;
      this.localForm.pick_location_id = null;
      this.localForm.pick_location = "";
      this.localForm.pick_city = "";
      this.localForm.pick_province = "";
      this.localForm.drop_location_id = null;
      this.localForm.drop_location = "";
      this.localForm.drop_city = "";
      this.localForm.drop_province = "";
      this.syncAreaSelections("pick");
      this.syncAreaSelections("drop");

      if (ev?.company_id) {
        this.loadLocations(ev.company_id);
      } else {
        this.fetchPickLocation = [];
        this.fetchDropLocation = [];
      }
    },

    loadTruckType() {
      const baseURI = this.$settings.endPointCt + "type-truck?select=select";
      return this.$http.get(baseURI).then((response) => {
        const trucks = response.data?.datas?.data || [];
        this.fetchTruckType = trucks.map((item) =>
          typeof item === "string"
            ? { type_truck: item }
            : { type_truck: item.type_truck || item }
        );
      });
    },

    loadCarrier() {
      const baseURI = this.$settings.endPointCt + "master-carrier";
      return this.$http.get(baseURI).then((response) => {
        this.fetchCarrier = response.data?.datas?.data || [];
      });
    },

    asyncCarrier(ev) {
      const baseURI =
        this.$settings.endPointCt + "master-carrier?carrier_name=" + (ev || "");
      return this.$http.get(baseURI).then((response) => {
        this.fetchCarrier = response.data?.datas?.data || [];
      });
    },

    loadLocations(companyId) {
      const companyIds = companyId === 0 ? [1] : [companyId, 1];
      const baseURI =
        this.$settings.endPoint + "transport-order-margin-list/stop-location?limit=3000";

      return this.$http.post(baseURI, { company_ids: companyIds }).then((response) => {
        const locations = response.data?.datas?.data || [];
        this.fetchPickLocation = locations;
        this.fetchDropLocation = locations;
        this.syncLocationFromOptions("pick");
        this.syncLocationFromOptions("drop");
        this.syncAreaSelections("pick");
        this.syncAreaSelections("drop");
      });
    },

    syncLocationFromOptions(type) {
      const formKey = type === "pick" ? "pick_location" : "drop_location";
      const idKey = type === "pick" ? "pick_location_id" : "drop_location_id";
      const cityKey = type === "pick" ? "pick_city" : "drop_city";
      const provinceKey = type === "pick" ? "pick_province" : "drop_province";
      const options = type === "pick" ? this.fetchPickLocation : this.fetchDropLocation;

      const currentValue = this.localForm[formKey];
      if (!currentValue) {
        return;
      }

      const selected = options.find((item) => {
        return (
          String(item.location_id || "") === String(this.localForm[idKey] || "") ||
          item.name === currentValue ||
          this.locationLabel(item) === currentValue
        );
      });

      if (!selected) {
        return;
      }

      if (type === "pick") {
        this.pickLocation = selected;
      } else {
        this.dropLocation = selected;
      }

      this.localForm[idKey] = selected.location_id || null;
      this.localForm[formKey] = selected.name || currentValue;
      this.localForm[cityKey] = this.localForm[cityKey] || selected.city || "";
      this.localForm[provinceKey] = this.localForm[provinceKey] || selected.province || "";
    },

    syncAreaSelections(type) {
      const cityKey = type === "pick" ? "pick_city" : "drop_city";
      const provinceKey = type === "pick" ? "pick_province" : "drop_province";
      const cityOptions = type === "pick" ? this.pickCityOptions : this.dropCityOptions;
      const provinceOptions =
        type === "pick" ? this.pickProvinceOptions : this.dropProvinceOptions;

      const selectedCity = this.localForm[cityKey]
        ? cityOptions.find((item) => item.city === this.localForm[cityKey]) || {
          city: this.localForm[cityKey],
          province: this.localForm[provinceKey] || "",
        }
        : null;

      const selectedProvince = this.localForm[provinceKey]
        ? provinceOptions.find((item) => item.name === this.localForm[provinceKey]) || {
          name: this.localForm[provinceKey],
        }
        : null;

      if (type === "pick") {
        this.pickCity = selectedCity;
        this.pickProvince = selectedProvince;
        return;
      }

      this.dropCity = selectedCity;
      this.dropProvince = selectedProvince;
    },

    onSelectPickLocation(ev) {
      this.localForm.pick_location_id = ev?.location_id || null;
      this.localForm.pick_location = ev?.name || "";
      this.localForm.pick_city = ev?.city || "";
      this.localForm.pick_province = ev?.province || "";
      this.syncAreaSelections("pick");
    },

    onSelectDropLocation(ev) {
      this.localForm.drop_location_id = ev?.location_id || null;
      this.localForm.drop_location = ev?.name || "";
      this.localForm.drop_city = ev?.city || "";
      this.localForm.drop_province = ev?.province || "";
      this.syncAreaSelections("drop");
    },

    onSelectPickCity(city) {
      this.localForm.pick_city = city?.city || "";

      const selectedCity = this.pickCityOptions.find((item) => item.city === city?.city);
      if (selectedCity?.province) {
        this.localForm.pick_province = selectedCity.province;
      }
      this.syncAreaSelections("pick");
    },

    onSelectPickProvince(province) {
      this.localForm.pick_province = province?.name || "";
      this.syncAreaSelections("pick");
    },

    onSelectDropCity(city) {
      this.localForm.drop_city = city?.city || "";

      const selectedCity = this.dropCityOptions.find((item) => item.city === city?.city);
      if (selectedCity?.province) {
        this.localForm.drop_province = selectedCity.province;
      }
      this.syncAreaSelections("drop");
    },

    onSelectDropProvince(province) {
      this.localForm.drop_province = province?.name || "";
      this.syncAreaSelections("drop");
    },

    //     loadChargeCode() {
    //       this.fetchChargeCode = [];

    //          const baseURI = this.$settings.endPointCt + "master-lookup?unique_id=mCharge";
    //      return this.$http.get(baseURI).then((response) => {
    //   this.fetchChargeCode = (response.data.datas || []).map(item => ({
    //     value: item.code,
    //     label: item.code
    //   }));
    // });
    //     },


    loadChargeCode() {
      this.fetchChargeCode = [];
      const baseURI = this.$settings.endPointCt + "master-lookup?unique_id=mCharge";
      return this.$http.get(baseURI).then((response) => {
        this.fetchChargeCode = this.normalizeChargeCode(response.data.datas);
        this.syncChargeCodeSelection();
      });
    },

    normalizeChargeCode(datas) {
      const rawItems = Array.isArray(datas)
        ? datas
        : Array.isArray(datas?.data)
          ? datas.data
          : [];

      return rawItems
        .map((item) => {
          if (typeof item === "string") {
            return {
              value: item,
              label: item,
            };
          }

          const value =
            item?.value ||
            item?.dependent ||
            item?.code ||
            item?.unique_id ||
            item?.description ||
            item?.dependent_name;

          if (!value) {
            return null;
          }

          return {
            value: String(value),
            label:
              item?.dependent_name ||
              item?.description ||
              item?.name ||
              String(value),
          };
        })
        .filter(Boolean);
    },

    syncChargeCodeSelection() {
      if (!this.localForm.charge_code) {
        return;
      }

      const selected = this.fetchChargeCode.find(
        (item) => item.value === this.localForm.charge_code || item.label === this.localForm.charge_code
      );

      if (selected) {
        this.chargeCode = selected;
      }
    },

    resetForm() {
      this.localForm = buildEmptyForm();
      this.company = null;
      this.truckType = null;
      this.carrier = null;
      this.chargeCode = null;
      this.pickLocation = null;
      this.dropLocation = null;
      this.pickCity = null;
      this.pickProvince = null;
      this.dropCity = null;
      this.dropProvince = null;
      this.fetchPickLocation = [];
      this.fetchDropLocation = [];
    },

    submitForm() {
      if (Number(this.localForm.max_value || 0) < Number(this.localForm.min_value || 0)) {
        window.alert("Max Value harus lebih besar atau sama dengan Min Value.");
        return;
      }

      // if (Number(this.localForm.max_percent || 0) < Number(this.localForm.min_percent || 0)) {
      //   window.alert("Max Percent harus lebih besar atau sama dengan Min Percent.");
      //   return;
      // }

      this.$emit("submit", {
        transport_order_margin_estimasi_id:
          this.localForm.transport_order_margin_estimasi_id || null,
        customer_id: this.company?.company_id || this.localForm.customer_id || null,
        customer_code: this.company?.code || this.localForm.customer_code || "",
        customer_name: this.company?.name || this.localForm.customer_name || "",
        pick_location_id:
          this.pickLocation?.location_id ?? this.localForm.pick_location_id ?? null,
        pick_location: this.pickLocation?.name || this.localForm.pick_location || "",
        pick_city: this.localForm.pick_city || "",
        pick_province: this.localForm.pick_province || "",
        drop_location_id:
          this.dropLocation?.location_id ?? this.localForm.drop_location_id ?? null,
        drop_location: this.dropLocation?.name || this.localForm.drop_location || "",
        drop_city: this.localForm.drop_city || "",
        drop_province: this.localForm.drop_province || "",
        type_truck: this.truckType?.type_truck || this.localForm.truck_type || "",
        carrier:
          this.carrier?.carrier_name || this.carrier?.carrier || this.localForm.carrier || "",
        billable_tariff: this.localForm.billable_tariff || "",
        charge_code: this.chargeCode?.value || this.localForm.charge_code || "",
        min_value: Number(this.localForm.min_value || 0),
        max_value: Number(this.localForm.max_value || 0),
        min_percent: Number(this.localForm.min_percent || 0),
        max_percent: Number(this.localForm.max_percent || 0),
      });
    },
  },
  mounted() {

    const formElement = this.$refs.formElement;
    if (formElement) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'readonly') {
            const inputs = formElement.querySelectorAll('.multiselect__input');
            inputs.forEach(input => {
              input.removeAttribute('readonly');  // Hapus readonly setiap kali diubah
            });
          }
        });
      });


      const inputs = formElement.querySelectorAll('.multiselect__input');
      inputs.forEach(input => {
        observer.observe(input, { attributes: true });
      });
    }


  },
};
</script>
